import { simpleObservableStore } from 'src/boot/simpleObservableStore';

import { UserConfigurationAndEffectiveRights } from 'src/models/user';

import { responseContainsRolloutCompatibleLegacyToken } from 'src/util/app/appCompatibility';
import { Callback } from 'src/util/query/models/Callback';

export class GetTheUserConfigurationAndEffectiveRightsQueryCallBack extends Callback<UserConfigurationAndEffectiveRights> {
	public constructor(
		private readonly setUserConfigurationAndEffectiveRights: (
			userConfigurationAndEffectiveRights: UserConfigurationAndEffectiveRights | null,
			userConfigurationAndEffectiveRightsUnavailable?: boolean
		) => void
	) {
		super();
	}

	private compatibilityHeaderFromFailureResponse(failureResponse: unknown): unknown {
		if (typeof failureResponse !== 'object' || failureResponse === null) {
			return undefined;
		}

		return (failureResponse as { response?: { headers?: Record<string, unknown> } }).response?.headers?.[
			'x-appcompatibility'
		];
	}

	private failureResponseIndicatesRolloutLegacyBackend(failureResponse: unknown): boolean {
		return (
			simpleObservableStore.usesRolloutCompatibleLegacyBackend ||
			responseContainsRolloutCompatibleLegacyToken(
				process.env.APP_COMPATIBILITY,
				this.compatibilityHeaderFromFailureResponse(failureResponse)
			)
		);
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		if (this.failureResponseIndicatesRolloutLegacyBackend(failureResponse)) {
			this.setUserConfigurationAndEffectiveRights(null, true);
		}
	};

	successCallbackFunction = (successResponse: UserConfigurationAndEffectiveRights): void => {
		this.setUserConfigurationAndEffectiveRights(successResponse);
	};
}
